import { render, staticRenderFns } from "./Destroyed.vue?vue&type=template&id=7d2572d1&"
import script from "./Destroyed.vue?vue&type=script&lang=js&"
export * from "./Destroyed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports